import {
    LISTAR_INTEGRACOES,
    // SELECIONAR_INTEGRACOES,
    LISTAR_RAMAIS,
    LISTAR_TRONCOS,
    LISTAR_TAGS,
    LISTA_SEGWARE,
    LISTAR_AUDIOS,
    LISTA_IA,
    LISTA_OPERADOR,
  } from './mutation-types'
  
  import IntegracoesHttpService from '../_services/IntegracoesHttpService'
  
  export default {
    listarIntegracoes: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getintegracoes()
        commit(LISTAR_INTEGRACOES, response.data)
      } catch (e) {
        console.log(e)
      }
    },
  
    // selecionarIntegracoes: async ({ commit }, _id) => {
    //   try {
    //     const response = await IntegracoesHttpService.gettarefa(_id)
    //     commit(SELECIONAR_INTEGRACOES, response.data)
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
  
    listaIntegracaoSegware: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getintegracaosegware()
        commit(LISTA_SEGWARE, response.data)
      } catch (e) {
        console.log(e)
      }
    },
  

    listarRamais: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getRamais()
        commit(LISTAR_RAMAIS, response.data.ramais)
      } catch (e) {
        console.log(e)
      }
    },

    listarTroncos: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getTroncos()
        commit(LISTAR_TRONCOS, response.data)
      } catch (e) {
        console.log(e)
      }
    },

    listarTags: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getTags()
        commit(LISTAR_TAGS, response.data)
      } catch (e) {
        console.log(e)
      }
    },

    listarAudios: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getAudios()
        commit(LISTAR_AUDIOS, response.data)
      } catch (e) {
        console.log(e)
      }
    },


    listaIntegracaoIA: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getintegracaoIA()
        commit(LISTA_IA, response.data)
      } catch (e) {
        console.log(e)
      }
    },
    listaOperadores: async ({ commit }) => {
      try {
        const response = await IntegracoesHttpService.getOperadores()
        commit(LISTA_OPERADOR, response.data)
      } catch (e) {
        console.log(e)
      }
    },
 
  }
  